import { render } from "./DirectTeam.vue?vue&type=template&id=5a8a9aae&scoped=true"
import script from "./DirectTeam.vue?vue&type=script&lang=js"
export * from "./DirectTeam.vue?vue&type=script&lang=js"

import "./DirectTeam.vue?vue&type=style&index=0&id=5a8a9aae&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8a9aae"]])

export default __exports__